export default function colorToHex(color) {
    if(!color) return

    let newColor = ''

    if(color.length == 9) {
        newColor = color.slice(0, color.length - 2)
    } else {
        newColor = color
    }

    return newColor
}